import { useUserContext } from '../infrastructure/UserContext';
import { useComercialContext } from '../../comercial/ComercialContext';
import { parseEquivalenceCharges } from '../domain/User.model';

/**
 * Régimen de recargo de equivalencia que aplica al carrito actual:
 * en modo comercial manda el del cliente representado, no el del usuario logueado
 * (el comercial puede no estar registrado como cliente y su recargo no significa nada aquí).
 *
 * @returns {EquivalenceCharges|undefined}
 */
export const useEffectiveEquivalenceCharges = () => {
  const { equivalenceCharges } = useUserContext();
  const { actingAsCliente, isComercialMode } = useComercialContext();

  if (isComercialMode && actingAsCliente?.recargo != null) {
    return parseEquivalenceCharges(actingAsCliente.recargo);
  }
  return equivalenceCharges;
};
